window.Page = {

    requestButtons    : document.querySelectorAll('.product-form-button'),
    requestContainers : document.querySelectorAll('.product-form-container'),

    openingImage : document.querySelector('.product-opening-image'),
    openingText  : document.querySelector('.product-information'),

    forms : document.querySelectorAll('.product-form'),

    // Let's launch this thing
    liftoff : () => {
        Page.showHideTheRequestForm()
        Page.setIntroStickyValue()
        Page.sendFormWithJS()
    },

    showHideTheRequestForm : () => {
        Page.requestButtons.forEach(requestButton => {            
            requestButton.addEventListener('click' , () => {
                requestButton.parentElement.classList.toggle('product-form-is-open')
            })
        })
    },

    // Set the correct sticky value for the intro text
    setIntroStickyValue : () => {

        function setStickyValue () {

            let offsetTop    = Page.openingImage.offsetTop
            let windowHeight = window.innerHeight
            let imageHeight  = Page.openingImage.clientHeight
            let stickyValue  = 0;

            // Check relative to what we need to place the text section
            let isImageTallerThanTheScreen = ((offsetTop + imageHeight) > windowHeight) ? true : false;

            if (isImageTallerThanTheScreen) {
                stickyValue = (windowHeight - Page.openingText.clientHeight) / 2;
            } else {
                stickyValue = (imageHeight + offsetTop - Page.openingText.clientHeight) / 2;
            }

            Page.openingText.style.top = `${stickyValue}px`;
        }

        window.addEventListener('load' , () => {setStickyValue()})
        window.addEventListener('resize' , () => {setStickyValue()})
    },

    // Prevent form submission and then do everything else with JS
    sendFormWithJS : () => {

        Page.forms.forEach(form => {

            form.addEventListener('submit' , event => {

                // Prevent the form from being submitted
                event.preventDefault()

                // Add the waiting class on the form
                form.parentElement.classList.add('submitting');

                // Grab the form data
                let formData = new FormData(form);

                const urlEncodedData = new URLSearchParams(formData).toString();

                // Use fetch to send a POST request and submit the form
                fetch("https://submit-form.com/ATBJEQBGe", {
                    method : "POST",
                    body: urlEncodedData,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Accept         : "application/x-www-form-urlencoded",
                    },
                })
                .then(function (response) {

                    // Remove the submitting function
                    form.parentElement.classList.remove('submitting','product-form-is-open');

                    // Update the button
                    form.previousElementSibling.innerHTML = "Thank You :)";
                    form.previousElementSibling.classList.add('disabled');
                    form.remove()

                    console.log(response);
                })
                .catch(function (error) {
                    form.parentElement.remove('submitting','product-form-is-open');
                    console.error(error);
                });



            })

        })
    }

};

Page.liftoff()